export default "/static/assets/product_user_output.29c208cb25762bbe28e8151dedff9374.png";